import React, { useEffect, useState } from "react";
import axiosInstance from "../../../utils/axiosInstance";
import Swal from "sweetalert2";
import DataTableComponent from "../../tools/DataTableComponent";
import { useFormik } from "formik";
import * as Yup from "yup";

const baseUrl = process.env.REACT_APP_BASE_URL;
const token = localStorage.getItem("token");

const validationSchema = Yup.object({
    name: Yup.string().required("Le nom est obligatoire"),
    email: Yup.string()
        .transform((value) => value === "" ? null : value)
        .nullable()
        .email("Email invalide"),
    phoneNumber: Yup.string()
        .transform((value) => value === "" ? null : value)
        .nullable(),
    cityId: Yup.number().required("La ville est obligatoire"),
    tierId: Yup.number().required("Le type est obligatoire"),
});

const TierEntity = ({ title, endpoint }) => {
    const [entities, setEntities] = useState([]);

    const [cities, setCities] = useState([]);
    const [tierTypes, setTierTypes] = useState([]);
    const [selectedEntity, setSelectedEntity] = useState(null);

    useEffect(() => {
        // if (!token) {
        //     return;
        // }
        fetchEntities();
        fetchCities();
        fetchTierTypes();
    }, [token]);

    const fetchEntities = () => {
        axiosInstance.get(`${baseUrl}/api/${endpoint}`)
            .then(res => setEntities(res.data))
            .catch(() => console.log("Impossible de charger les données"));
    };

    const fetchCities = () => {
        axiosInstance.get(`${baseUrl}/api/${endpoint}/villes`)
            .then(res => setCities(res.data));
    };

    const fetchTierTypes = () => {
        const category = title === "Fournisseurs" ? "1" : "0";
        axiosInstance.get(`${baseUrl}/api/TierTypes/category/${category}`)
            .then(res => setTierTypes(res.data));
    };

    const formik = useFormik({
        initialValues: {
            id: 0,
            name: "",
            contactName: "",
            email: "",
            phoneNumber: "",
            address: "",
            cityId: "",
            tierId: "",
            cityName: "",
            tierName: ""
        },
        validationSchema,
        onSubmit: async (values, { setErrors, resetForm }) => {
            const url = values.id
                ? `${baseUrl}/api/${endpoint}/UpdateElement`
                : `${baseUrl}/api/${endpoint}/CreateElement`;
            console.log("data client et fournisseur : ", values)
            const payload = {
                ...values,
                id: parseInt(values.id, 10),
                cityId: parseInt(values.cityId, 10),
                tierId: parseInt(values.tierId, 10),
                phoneNumber: values.phoneNumber ?? "",
                address: values.address ?? "",
                contactName: values.contactName ?? "",
                email: values.email ?? "",
            };

            try {
                await axiosInstance.post(url, payload);

                window.$("#modalForm").modal("hide");

                Swal.fire({
                    toast: true,
                    position: "top-end",
                    icon: "success",
                    title: "Enregistrement effectué avec succès",
                    showConfirmButton: false,
                    timer: 2000,
                });

                fetchEntities();
                resetForm();
                setSelectedEntity(null);

            } catch (error) {
                // 🔴 erreurs backend (ServiceResponse / ModelState)
                if (error.response?.data?.errors) {
                    setErrors(error.response.data.errors);
                } else {
                    Swal.fire({
                        toast: true,
                        position: "top-end",
                        icon: "error",
                        title: "Opération échouée",
                        showConfirmButton: false,
                        timer: 2000,
                    });
                }
            }
        }
    });

    const resetForm = () => {
        formik.resetForm();
        setSelectedEntity(null);
    };

    const handleEdit = (entity) => {
        setSelectedEntity(entity);
        formik.setValues(entity);

        setTimeout(() => {
            window.$("#modalForm").modal("show");
        }, 100);
    };


    const handleDelete = (id) => {
        Swal.fire({
            title: "Êtes-vous sûr ?",
            text: "Cette action est irréversible !",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Oui, supprimer"
        }).then((result) => {
            if (result.isConfirmed) {
                axiosInstance.post(`${baseUrl}/api/${endpoint}/DeleteElement`,
                    { 'id': id, 'idString': '' })
                    .then(() => fetchEntities());
            }
        });
    };

    return (
        <div className="container-fluid mt-4">
            <h3 className="text-center my-3">{title}</h3>
            <button className="btn btn-primary btn-ajouter mb-3" data-toggle="modal" data-target="#modalForm" onClick={resetForm}><i className="fas fa-plus"></i>Ajouter</button>
            <DataTableComponent
                title={title}
                columns={["name", "contactName", "email", "phoneNumber", "address", "cityName"]}
                columnsMapping={{
                    name: "Nom",
                    contactName: "Contact",
                    email: "Email",
                    phoneNumber: "Téléphone",
                    address: "Adresse",
                    cityName: "Ville"
                }}
                keyField="id"
                data={entities}
                handleEdit={handleEdit}
                handleDelete={(id) => handleDelete(id)}
            />

            {/* Modal Form */}
            <div className="modal fade" id="modalForm">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5>{selectedEntity ? "Modifier" : "Ajouter"} {title}</h5>
                            <button type="button" className="close" data-dismiss="modal">
                                <span>&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="form-group">
                                <label>Nom</label>
                                <input
                                    type="text"
                                    name="name"
                                    className={`form-control ${formik.touched.name && formik.errors.name ? "is-invalid" : ""}`}
                                    value={formik.values.name}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                                <div className="invalid-feedback">{formik.errors.name}</div>
                            </div>

                            <div className="form-group">
                                <label>Nom du Contact</label>
                                <input
                                    type="text"
                                    name="contactName"
                                    className="form-control"
                                    value={formik.values.contactName}
                                    onChange={formik.handleChange}
                                />
                            </div>

                            <div className="form-group">
                                <label>Email</label>
                                <input
                                    type="email"
                                    name="email"
                                    className={`form-control ${formik.touched.email && formik.errors.email ? "is-invalid" : ""}`}
                                    value={formik.values.email}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                                <div className="invalid-feedback">{formik.errors.email}</div>
                            </div>

                            <div className="form-group">
                                <label>Téléphone</label>
                                <input
                                    type="text"
                                    name="phoneNumber"
                                    className="form-control"
                                    value={formik.values.phoneNumber}
                                    onChange={formik.handleChange}
                                />
                                <div className="invalid-feedback">{formik.errors.phoneNumber}</div>
                            </div>

                            <div className="form-group">
                                <label>Adresse</label>
                                <input
                                    type="text"
                                    name="address"
                                    className="form-control"
                                    value={formik.values.address}
                                    onChange={formik.handleChange}
                                />
                            </div>

                            <div className="form-group">
                                <label>Ville</label>
                                <select
                                    name="cityId"
                                    className={`form-control ${formik.touched.cityId && formik.errors.cityId ? "is-invalid" : ""}`}
                                    value={formik.values.cityId}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                >
                                    <option value="">Sélectionner une ville</option>
                                    {cities.map(c => (
                                        <option key={c.id} value={c.id}>{c.nameLat}</option>
                                    ))}
                                </select>
                                <div className="invalid-feedback">{formik.errors.cityId}</div>
                            </div>

                            <div className="form-group">
                                <label>{title === "Fournisseurs"
                                    ? "Type Fournisseur"
                                    : title === "Clients"
                                        ? "Type Client"
                                        : "Type de Tier"}</label>
                                <select
                                    name="tierId"
                                    className={`form-control ${formik.touched.tierId && formik.errors.tierId ? "is-invalid" : ""}`}
                                    value={formik.values.tierId}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                >
                                    <option value="">Sélectionner un type</option>
                                    {tierTypes.map(t => (
                                        <option key={t.id} value={t.id}>{t.nameLat}</option>
                                    ))}
                                </select>
                                <div className="invalid-feedback">{formik.errors.tierId}</div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-secondary" data-dismiss="modal" onClick={resetForm}>Annuler</button>
                            <button className="btn btn-primary" onClick={formik.handleSubmit}>Sauvegarder</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TierEntity;
